export const interestType = {
  VAR: "VAR",
  FIX: "FIX"
};
